export default "__VITE_ASSET__DFB1_EDE__"